import styled, { css } from 'styled-components';
import { hideScroll } from 'styled-manila';
import { getColor } from 'core/utils';
export const Wrapper = styled.div`
	background: ${getColor('white')};
	z-index: 9;

	${props => props.isSticky && css`
		height: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		border: 1px solid ${getColor('alto')};
	`}
`;

export const Overflower = styled.div`
	overflow-y: auto;
	height: 100%;
	${hideScroll}
`;

export const TitleWrapper = styled.div`
	@media (min-width: 768px) {
		${({ isSticky }) => isSticky && css`
			padding: 16px 16px 0;
		`}
	}
`;
